// Central site configuration. Replace null values with verified details only.
export const COMPANY = {
  name: "Suvirika Retail Pvt Ltd",
  shortName: "Suvirika Retail",
  logo: "/brand/suvirika-logo.png",
  mark: "/brand/suvirika-mark.png",
  intro:
    "A multi-brand Indian retail and consumer products company building businesses across distribution, beauty, FMCG, fashion, accessories, and everyday consumer essentials.",
  contact: {
    address: "6th Floor, Ecospace Business Park, Newtown, Kolkata 700156",
    email: "enquiry@suvirika.com",
    phone: "+91 70505 02020",
    website: null,
  },
  social: {
    linkedin: null,
    instagram: null,
    facebook: null,
    x: null,
  },
};

// Brand portfolio. `url` and `logo` stay null until official values are supplied.
export const BRANDS = [
  {
    id: "99-distributor",
    name: "99 Distributor",
    category: "B2B Distribution & Commerce",
    description:
      "A B2B distribution and marketplace platform connecting manufacturers, distributors, and retailers to support product discovery, business enquiries, and market expansion.",
    image: "/images/b-99distributor.jpg",
    imageAlt: "Tall warehouse racks stacked with cartons",
    url: "https://www.99distributor.com",
    logo: "/brand/99-distributor.png",
    tone: "blue",
  },
  {
    id: "grofkart",
    name: "Grofkart",
    category: "Local Retail & Commerce",
    description:
      "A retailer-first local commerce initiative designed to connect neighbourhood retailers with customers and support convenient access to everyday products.",
    image: "/images/b-grofkart.jpg",
    imageAlt: "A neighbourhood store stocked with everyday goods",
    url: "https://www.grofkart.com",
    logo: "/brand/grofkart.png",
    tone: "pink",
  },
  {
    id: "avikka-cosmetics",
    name: "Avikka Cosmetics",
    category: "Premium Affordable Beauty",
    description:
      "An accessible beauty and personal care brand focused on bringing thoughtfully developed cosmetics and everyday beauty essentials to a wider audience.",
    image: "/images/b-avikka.jpg",
    imageAlt: "Lip colours and a foundation bottle on marble",
    url: "https://www.avikka.com",
    logo: "/brand/avikka-cosmetics.png",
    tone: "pink",
  },
  {
    id: "nanshya",
    name: "Nanshya",
    category: "FMCG & Everyday Essentials",
    description:
      "A consumer-focused FMCG brand built around everyday product categories and practical household and personal-use needs.",
    image: "/images/b-nanshya.jpg",
    imageAlt: "Organised shelves of packaged everyday products",
    url: "https://www.nanshya.com",
    logo: "/brand/nanshya.png",
    tone: "blue",
  },
  {
    id: "suvikka",
    name: "Suvikka",
    category: "Accessories & Lifestyle",
    description:
      "A lifestyle and accessories brand spanning jewellery, belts, bags, and complementary everyday fashion accessories.",
    image: "/images/b-suvikka.jpg",
    imageAlt: "Gold and silver jewellery arranged on a light surface",
    url: "https://www.suvikka.com",
    logo: "/brand/suvikka.png",
    tone: "blue",
  },
  {
    id: "zeya",
    name: "Zeya",
    category: "Lingerie & Intimate Apparel",
    description:
      "A dedicated intimate-apparel brand focused on lingerie and personal wardrobe essentials.",
    image: "/images/b-zeya.jpg",
    imageAlt: "Soft folds of ivory silk fabric",
    url: "https://www.zeyalingerie.com",
    logo: "/brand/zeya.png",
    tone: "pink",
  },
  {
    id: "krystal",
    name: "Krystal",
    category: "Home Care & Cleaning",
    description:
      "A household cleaning and home-care brand covering everyday essentials such as dishwashing products, floor cleaners, toilet cleaners, and washing powders.",
    image: "/images/b-krystal.jpg",
    imageAlt: "Minimal white cleaning bottles on a table",
    url: "https://www.krystal.com",
    logo: "/brand/krystal.png",
    tone: "blue",
  },
  {
    id: "suvika-cosmetics",
    name: "Suvika Cosmetics",
    category: "Affordable Beauty & Trending Fashion",
    description:
      "A value-led consumer brand focused on affordable cosmetics, beauty discoveries priced under ₹149, and trending clothing.",
    image: "/images/b-suvika.jpg",
    imageAlt: "Makeup brushes and colourful cosmetics flat lay",
    url: null,
    logo: "/brand/suvika-cosmetics.png",
    tone: "pink",
  },
];

export const ENQUIRY_TYPES = [
  "Manufacturing & Supply Partnerships",
  "Distribution & Retail Partnerships",
  "Brand & Business Collaborations",
  "Careers & Professional Opportunities",
];

export const BRAND_OPTIONS = ["Suvirika Retail (Group)", ...BRANDS.map((b) => b.name)];

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About Us" },
  { to: "/brands", label: "Our Brands" },
  { to: "/business-approach", label: "Business Approach" },
  { to: "/careers", label: "Careers" },
  { to: "/contact", label: "Contact" },
];

export const PILLARS = [
  {
    n: "01",
    title: "Market Connectivity",
    text: "Bringing businesses closer to relevant markets and trade opportunities.",
  },
  {
    n: "02",
    title: "Consumer Categories",
    text: "Developing brands across beauty, lifestyle, FMCG, fashion, and household essentials.",
  },
  {
    n: "03",
    title: "Retail Enablement",
    text: "Supporting retail discovery, distribution, and local commerce.",
  },
  {
    n: "04",
    title: "Brand Development",
    text: "Building distinct brand identities for different customer needs and market segments.",
  },
];
